module.exports = __webpack_public_path__ + "media/images/searchicon-0027d1bb79bf0cbcc37b79191995378f.jpeg";